import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import { makeStyles } from 'tss-react/mui';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { fetchNewsFeed } from '../store/actions/index';

const useStyles = makeStyles()(() => ({
  paper: {
    display: `flex`,
  },
  cover: {
    width: 100,
    flexShrink: 0,
  },
  root: {
    flexGrow: 1,
    padding: `0 1rem`,
  },
  content: {
    padding: `10px`,
    '&:last-child': {
      paddingBottom: `10px`,
    }
  },
}));

const NewsFeed = () => {
  const news = useSelector((state) => state.news.all);
  const dispatch = useDispatch();
  const { classes } = useStyles();

  useEffect(() => {
    dispatch(fetchNewsFeed());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderItems = () => {
    return map(news, (item) => {
      const imgSmall = item.media.sizes.thumbnail.source_url;

      return (
        <Grid item xs={12} sm={6} md={4} key={item.slug}>
          <Card className={classes.paper}>
            <Link
              to={`/news/${item.slug}`}
              className={classes.cover}
            >
              <img
                src={imgSmall}
                alt={item.title}
              />
            </Link>
            <CardContent className={classes.content}>
              <Link
                to={`/news/${item.slug}`}
              >
                <Typography variant="body2" component="p">
                  <span dangerouslySetInnerHTML={{__html: item.title}} />
                </Typography>
              </Link>
            </CardContent>
          </Card>
        </Grid>
      );
    });
  }

  return (
    <div className="home--container">
      <h2 className="home--heading">Recent news</h2>
      <div className={classes.root}>
        <Grid container spacing={3}>
          {renderItems()}
        </Grid>
      </div>
    </div>
  );
}

NewsFeed.propTypes = {
  fetchNewsFeed: PropTypes.func,
  news: PropTypes.array,
}

export default NewsFeed;
